import { 
    GET_DOMAIN_LIST_FAILED, GET_DOMAIN_LIST_SUCCESS, ADD_NEW_DOMAIN_FAILED, ADD_NEW_DOMAIN_SUCCESS, 
    //ADD_NEW_DOMAIN_REQUEST 
} from "../Actions/DomainAction";
import { call, put } from "redux-saga/effects";
import axios from "../../axiosConfig";
import { TOAST_SHOW } from "../Actions/ToastAction";


export function* AddNewDomainSaga(action: any): unknown {
    try {
        const response = yield call(axios.post, 'add-domain', action.newDomain);
        const { data, status } = response

        if (status === 200) {
            yield put({ type: ADD_NEW_DOMAIN_SUCCESS, payload: data });
            yield put({
                type: TOAST_SHOW,
                payload: { message: 'New Domain added successfully', severity: 'Success', show: true },
            });
        }

    } catch (e: any) {
        yield put({ type: ADD_NEW_DOMAIN_FAILED, payload: [] });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}


export function* GetDomainListSaga(action: any): unknown {
    try {
        const response = yield call(axios.get, `getDomain`);
        const { data, status } = response

        if (status === 200) {
            yield put({ type: GET_DOMAIN_LIST_SUCCESS, payload: data });
        }

    } catch (e: any) {
        yield put({ type: GET_DOMAIN_LIST_FAILED, payload: [] });
    }
}
